import React from 'react'

const TicketAltIcon = props => (
  <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.98594 0.945129L4.68707 0.945129C4.70658 1.67951 5.30803 2.26885 6.04712 2.26885C6.78622 2.26885 7.38766 1.67951 7.40717 0.945129L9.10838 0.945129C10.2355 0.945129 11.1492 1.85883 11.1492 2.98594V12.5097C11.1492 13.6368 10.2355 14.5505 9.10838 14.5505H7.40739C7.39084 13.8135 6.78819 13.2211 6.0472 13.2211C5.3062 13.2211 4.70356 13.8135 4.687 14.5505H2.98594C1.85883 14.5505 0.945129 13.6368 0.945129 12.5097L0.945129 2.98594C0.945129 1.85883 1.85883 0.945129 2.98594 0.945129Z"
      fill="#556B80"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6713 2.87905L13.1446 3.72964C12.7943 4.37539 13.0205 5.18647 13.6606 5.55601C14.3007 5.92555 15.1162 5.7159 15.5003 5.08969L16.9735 5.94027C17.9496 6.50382 18.2841 7.75196 17.7205 8.72807L12.9586 16.9759C12.3951 17.952 11.1469 18.2865 10.1708 17.7229L8.69763 16.8724C9.0518 16.2258 8.82608 15.4115 8.18437 15.041C7.54265 14.6705 6.72456 14.8822 6.34171 15.5122L4.86862 14.6617C3.89251 14.0981 3.55808 12.85 4.12163 11.8739L8.88352 3.62604C9.44708 2.64993 10.6952 2.31549 11.6713 2.87905Z"
      fill="currentColor"
    />
  </svg>
)

export default TicketAltIcon
